import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'paper-cover',
    styles: [
        `
        .paper-cover {
            position: fixed;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            z-index: 2000;
            background-color: rgba(0,0,0,0.9);
        }
        .paper-cover .cover-content {
            overflow: auto;
        }
        .paper-cover .title {
            text-align: center;
            color: #ccc;
            font-size: 24px;
            margin-left: 20px;
        }
        `
    ],
    template: `
        <div class="paper-cover animated {{effect}}">
            <div class="layout-column layout-padding h-100">
                <div class="flex-nogrow layout-row">
                    <div class="layout-row layout-align-center-center">
                        <div class="flex-nogrow">
                            <bw-button 
                                        *ngIf="closeIcon" 
                                        color="red" 
                                        icon="{{closeIcon}}" 
                                        [circular]="true" 
                                        (click)="close($event)
                            ">
                            </bw-button>
                        </div>
                        <div class="flex title text-center">{{title}}</div>
                    </div>
                </div>
                <div class="flex cover-content">
                    <ng-content></ng-content>
                </div>
            </div>
        </div>
    `,
})
export class PaperCoverComponent {
    @Input() title: string;
    @Input() effect = 'slideInRight';
    @Input() outEffect = 'slideOutRight';
    @Input() closeIcon = 'chevron-right';

    @Output() closed = new EventEmitter();

    close(e: MouseEvent) {
        e.preventDefault();
        this.effect = this.outEffect;
        setTimeout(() => this.closed.emit(), 1200);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/ui/paper-cover/paper-cover.component.ts